import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaUser, FaCog, FaSignOutAlt } from 'react-icons/fa';

function ClientProfileDropdown({ user, onLogout }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getUserInitials = () => {
    if (user?.name) {
      return user.name.charAt(0).toUpperCase();
    }
    return 'C';
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
      >
        <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-semibold" style={{ backgroundColor: '#00A86B' }}>
          {getUserInitials()}
        </div>
        <span className="text-sm font-medium" style={{ color: '#0A1929' }}>
          {user?.name || 'Client'}
        </span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border py-1 z-50" style={{ borderColor: '#E8ECEF' }}>
          <div className="px-4 py-2 border-b" style={{ borderColor: '#E8ECEF' }}>
            <p className="text-sm font-medium" style={{ color: '#0A1929' }}>{user?.name || 'Client'}</p>
            <p className="text-xs" style={{ color: '#4A5568' }}>{user?.email || 'client@company.com'}</p>
          </div>
          
          <Link
            to="/client-profile"
            className="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors"
            style={{ color: '#0A1929' }}
            onClick={() => setIsOpen(false)}
          >
            <FaUser size={14} /> My Profile
          </Link>
          
          <Link
            to="/client-settings"
            className="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors"
            style={{ color: '#0A1929' }}
            onClick={() => setIsOpen(false)}
          >
            <FaCog size={14} /> Settings
          </Link>
          
          <div className="border-t my-1" style={{ borderColor: '#E8ECEF' }}></div>
          
          <button
            onClick={() => {
              setIsOpen(false);
              onLogout();
            }}
            className="w-full flex items-center gap-3 px-4 py-2 text-sm hover:bg-red-50 transition-colors"
            style={{ color: '#EF4444' }}
          >
            <FaSignOutAlt size={14} /> Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default ClientProfileDropdown;
